import { CSSObject } from "@emotion/react";
import {
  typographyStyles,
  constants,
  mediaQueryStyles,
} from "@newsela/angelou";
const {
  Breakpoints,
  BreakpointNames: { sm },
} = constants.breakpoints;

const { mediaQuery: mq } = mediaQueryStyles;
const { heading2Obj } = typographyStyles;

export const wrapperCss: CSSObject = {
  margin: "0 auto",
  maxWidth: `${Breakpoints.lg}px`,
  padding: "32px",
  [mq.upTo(sm)]: {
    padding: "16px",
  },
};

export const previewTitleContainerCss: CSSObject = {
  display: "grid",
  gap: "32px",
  marginBottom: "64px",
};

export const previewTitleCss: CSSObject = {
  ...heading2Obj,
  fontWeight: 700,
};

export const previewSubtitleCss: CSSObject = {
  fontWeight: 700,
};

export const rowsContainerCss: CSSObject = {
  [mq.upTo(sm)]: {
    padding: "16px",
  },
  display: "grid",
  gap: "32px",
};

export const noReponsesMessageContainerCss: CSSObject = {
  padding: "16px 80px",
  marginBottom: "80px",
};
